import { render, staticRenderFns } from "./newsVol.vue?vue&type=template&id=87f0f714&scoped=true&"
import script from "./newsVol.vue?vue&type=script&lang=js&"
export * from "./newsVol.vue?vue&type=script&lang=js&"
import style0 from "./newsVol.vue?vue&type=style&index=0&id=87f0f714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f0f714",
  null
  
)

export default component.exports